import React from 'react';
// styles
import styled from 'styled-components';

const CancelIcon = ({ className, ...props }) => (
  <svg
    {...props}
    aria-label="Cancel"
    className={className}
    role="img"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="4" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 5L10.0048 4H14.0034L15.0028 5H9ZM6 5H18V7H6V5ZM17 8H7V18C7 19.1046 7.89543 20 9 20H15C16.1046 20 17 19.1046 17 18V8Z"
      fill="#CCD6E0"
    />
    <mask
      id="mask0_2835_27647"
      maskUnits="userSpaceOnUse"
      x="6"
      y="4"
      width="12"
      height="16"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 5L10.0048 4H14.0034L15.0028 5H9ZM6 5H18V7H6V5ZM17 8H7V18C7 19.1046 7.89543 20 9 20H15C16.1046 20 17 19.1046 17 18V8Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_2835_27647)"></g>
  </svg>
);

export default styled(CancelIcon)``;
